<app-loader *ngIf="!isDataReady"></app-loader>
<div class="ui-g" *ngIf="isDataReady">

    <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">


        <div style="margin-bottom:10px">

            <div *ngIf="showFilters">
                <div class="ui-g">
                    <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-3">
                        <span class="ui-float-label">
                            <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                             dateFormat="dd.mm.yy"  [(ngModel)]="orderFrame.dateFrom"></p-calendar>
                            <label for="float-input">Data zakupu od</label>
                        </span>
                    </div>

                    <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-3">
                        <span class="ui-float-label">
                            <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                             dateFormat="dd.mm.yy"   [(ngModel)]="orderFrame.dateTo"></p-calendar>
                            <label for="float-input">Data zakupu do</label>
                        </span>
                    </div>


                    <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-3">
                        <span class="ui-float-label">
                            <p-dropdown [autoDisplayFirst]="false" [style]="{'width':'100%'}" [options]="payStatuses"
                                [(ngModel)]="orderFrame.isPaid" (onChange)="this.onFilter()"></p-dropdown>
                            <label for="float-input">Status płatności</label>
                        </span>
                    </div>

                    <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-3">
                        <span class="ui-float-label">
                            <p-dropdown [options]="createdDocumentStatuses" [style]="{'width':'100%'}"
                                [(ngModel)]="orderFrame.isCreatedDocument" (onChange)="this.onFilter()"></p-dropdown>
                            <label for="float-input">Wystawiono dokument</label>
                        </span>
                    </div>

                    <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-3">
                        <span class="ui-float-label">
                            <p-dropdown [options]="orderStatuses" [style]="{'width':'100%'}"
                                [(ngModel)]="orderFrame.status" (onChange)="this.onFilter()"></p-dropdown>
                            <label for="float-input">Status zamówienia</label>
                        </span>
                    </div>

                    <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-3">
                        <span class="ui-float-label">
                            <p-dropdown [style]="{'width':'100%'}" [options]="paymentTypeStatuses"
                                [(ngModel)]="orderFrame.paymentType" (onChange)="this.onFilter()"></p-dropdown>
                            <label for="float-input">Rodzaj płatności</label>
                        </span>
                    </div>


                    <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-3">
                        <span class="ui-float-label">
                            <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                            dateFormat="dd.mm.yy"  [(ngModel)]="orderFrame.paymentFrom"></p-calendar>
                            <label for="float-input">Data płatności od</label>
                        </span>
                    </div>

                    <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-3">
                        <span class="ui-float-label">
                            <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                            dateFormat="dd.mm.yy"   [(ngModel)]="orderFrame.paymentTo"></p-calendar>
                            <label for="float-input">Data płatności do</label>
                        </span>
                    </div>

                    <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                        <span class="ui-float-label">
                        </span>
                        <div style="font-size: 14px; line-height: 1.4;">
                            Suma zamówień (brutto): {{totalPrice | currencyReduce:true | currency:'PLN' }}<br/>
                            Pobory dla aranżerów (netto): {{totalPrice2 | currencyReduce:true | currency:'PLN' }}<br/>
                            Zysk (netto): {{totalPrice3 | currencyReduce:true | currency:'PLN' }}<br/>
                        </div>

                    </div>


                    <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                        <button pButton type="button" label="Filtruj" (click)="this.onFilter()"></button>
                    </div>
                </div>
            </div>

            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div style="text-align: right;">
                    <button *ngIf="!showFilters" pButton type="button" label="Filtry"
                        (click)="this.onToggleFilter()"></button>
                </div>
            </div>
        </div>


        <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
            <p-panel
                [styleClass]="(order.is_paid == true ? 'paid' : (order.status == statusPaymentEnum.CANCELLED) ? 'canceled' : 'not_paid')"
                [style]="{'color':'#333333', 'background-color':'#f4f4f4', 'margin-bottom': '20px'}"
                *ngFor="let order of orders">
                <p-header>
                    <div class="ui-helper-clearfix">
                        <div class="order">

                            <div>
                                <span class="ui-panel-title">
                                    {{ 'order_no' | translate }}: {{ order.id }}
                                </span>
                            </div>

                            <div class="orderHeader">
                                <button *ngIf="order.invoice"
                                    [ngClass]="{'downloaded': order.invoice.is_downloaded_by_admin === true}"
                                    (click)="this.onDownloadInvoice(order)" mat-button color="primary">Pobierz
                                    fakturę <i *ngIf="order.invoice.is_downloaded === true" class="pi pi-check"></i>
                                </button>

                                <span *ngIf="order.manual_invoice" style="margin-top: 6px; color: #2e7d32; font-weight: 600;">
                                    Dodano plik faktury
                                </span>

                                <button (click)="this.onEditOrder(order)" mat-button color="primary">Edycja</button>
                            </div>

                        </div>

                    </div>
                </p-header>

                <div class="p-grid">
                    <div class="p-col-7 p-sm-5 p-md-6 p-lg-6 p-xl-9">
                        <div *ngFor="let item of order.items; index as i">
                            <div>
                                <div class="p-grid">
                                    <div class="orderItem p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
                                        <span class="orderItemTitle">{{ i+1 }}. {{ item.title }}
                                            ({{ item.note.arranger.user_details.name }}
                                            {{ item.note.arranger.user_details.surname }})
                                            {{item.price | currencyReduce:true:order.currency_histories.exchange_rate |
                                            currency:order.currency_histories.currency_code }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-5 p-sm-5 p-md-6 p-lg-6 p-xl-3">
                        <div>
                            {{order.customer.user_details.name}} {{order.customer.user_details.surname}}<br />
                            {{order.customer.email}}<br />
                            {{order.customer.user_details.phone}}
                        </div>

                    </div>
                </div>

                <div class="orderFooterLine"></div>
                <div class="p-grid">
                    <div class="p-col-6 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                        <div style="display: flex;justify-content: flex-start;">
                            <div style="display: flex;flex-direction: column;">
                                <span>{{ 'order_date' | translate }}: {{ order.created_at | date:'dd.MM.yyyy, HH:mm:ss' }}</span>
                                <span *ngIf="order.payment_date">{{ 'payment_date' | translate }}: {{ order.payment_date | date:'dd.MM.yyyy, HH:mm:ss' }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-6 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                        <div style="display: flex;justify-content: flex-end;">
                            <div class="orderDetial"> {{(order.is_paid) ? "Zapłacone" : "Oczekuje na wpłatę"}}</div>

                            <div class="orderDetial"> {{order.payment_type}}</div>

                            <span>Suma:
                                {{order.items | orderTotal | currencyReduce:true:order.currency_histories.exchange_rate
                                | currency:order.currency_histories.currency_code }}</span>
                        </div>
                    </div>
                </div>
            </p-panel>
        </div>


        <div *ngIf="orders.length == 0" class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
            <p-panel>
                <div style="display: flex;justify-content: center;">
                    {{'orders_empty_orders' | translate}}
                </div>
            </p-panel>

        </div>

    </div>
</div>

<app-loader *ngIf="paginateLoader"></app-loader>
<p-paginator *ngIf="isDataReady && orders.length != 0" [rows]="limit" [totalRecords]="totalOrders"
    (onPageChange)="paginate($event)"></p-paginator>

<p-dialog styleClass="editedPanel" *ngIf="selectedEditOrder" [modal]="true"
    [header]="'Edycja zamówienia numer ' + selectedEditOrder?.id" [(visible)]="showEditPanel">
    <div class="ui-g">

        <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-3">
            <div class="ui-g">
                <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                    <div style="display: block;font-weight: bold;">Zamawiający:</div>
                    <div style="display: block;">{{selectedEditOrder.customer.user_details.name}}
                        {{selectedEditOrder.customer.user_details.surname}}<br />
                        {{selectedEditOrder.customer.email}}<br />
                        {{selectedEditOrder.customer.user_details.phone}}</div>
                </div>
            </div>
        </div>


        <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-9">
            <div class="ui-g">
                <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-6">
                    <span class="ui-float-label">
                        <p-dropdown [style]="{'width':'100%'}" [options]="this.filterProperty(payStatuses)"
                            [(ngModel)]="selectedEditOrder.is_paid"></p-dropdown>
                        <label for="float-input">Status płatności</label>
                    </span>
                </div>

                <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-6">
                    <span class="ui-float-label">
                        <p-dropdown [options]="this.filterProperty(orderStatuses)" [style]="{'width':'100%'}"
                            [(ngModel)]="selectedEditOrder.status"></p-dropdown>
                        <label for="float-input">Status zamówienia</label>
                    </span>
                </div>

                <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-6">
                    <span class="ui-float-label">
                        <p-dropdown [options]="this.filterProperty(paymentTypeStatuses)" [style]="{'width':'100%'}"
                            [(ngModel)]="selectedEditOrder.payment_type"></p-dropdown>
                        <label for="float-input">Forma płatności</label>
                    </span>
                </div>

                <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                    <span class="ui-float-label">
                        <textarea rows="5" [style]="{'width':'100%'}" pInputTextarea
                            [(ngModel)]="selectedEditOrder.description_admin"></textarea>
                        <label for="float-input">Dodatkowy opis</label>
                    </span>
                </div>
            </div>
        </div>


        <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
            <div class="ui-g">
                <button pButton type="button" label="Zapisz" (click)="onSaveEditedOrder()"></button>
            </div>
        </div>

        <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
            <hr />
        </div>

        <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
            <h4 style="margin:0;padding:0">Plik faktury dla klienta</h4>
            <div style="margin-top: 10px;">
                <div *ngIf="selectedEditOrder.manual_invoice" style="margin-bottom: 10px;">
                    <div><strong>Nazwa pliku:</strong> {{ selectedEditOrder.manual_invoice.original_name }}</div>
                    <div><strong>Dodano:</strong> {{ selectedEditOrder.manual_invoice.created_at | date:'dd.MM.yyyy, HH:mm:ss' }}</div>
                </div>

                <div *ngIf="!selectedEditOrder.manual_invoice" style="margin-bottom: 10px;">
                    Brak dodanego pliku faktury.
                </div>

                <input #manualInvoiceInput type="file" accept=".pdf,.jpg,.jpeg,.png" style="display: none;"
                    (change)="onManualInvoiceChange($event)">

                <button pButton type="button"
                    [label]="selectedEditOrder.manual_invoice ? 'Podmień plik faktury' : 'Dodaj plik z fakturą'"
                    (click)="onOpenManualInvoicePicker(manualInvoiceInput)"
                    [disabled]="uploadingManualInvoice"
                    style="margin-right: 8px;">
                </button>

                <button *ngIf="selectedEditOrder.manual_invoice" pButton type="button" class="ui-button-secondary"
                    label="Pobierz plik" (click)="onDownloadManualInvoice(selectedEditOrder)" style="margin-right: 8px;">
                </button>

                <button *ngIf="selectedEditOrder.manual_invoice" pButton type="button" class="ui-button-danger"
                    label="Usuń plik" (click)="onDeleteManualInvoice()" [disabled]="deletingManualInvoice">
                </button>

                <div style="margin-top: 10px;" *ngIf="uploadingManualInvoice || deletingManualInvoice">
                    <app-loader [center]="false" [size]="30"></app-loader>
                </div>
            </div>
        </div>

        <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
            <hr />
        </div>

        <div style="text-align: center;" *ngIf="!selectedEditOrder.invoice_details">Brak możliwości zmiany danych do faktury - zamówienie migracyjne</div>

        <div *ngIf="selectedEditOrder.invoice_details" style="width:100%" class="order-management">
            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <h4 style="margin:0;padding:0">Dane do faktury</h4>
            </div>

            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <label class="label">Nazwa firmy / Imię nazwisko</label>
                    <input class="input-invoice" type="text" pInputText
                        [(ngModel)]="selectedEditOrder.invoice_details.name">
                </div>
            </div>


            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <label class="label">NIP</label>
                    <input class="input-invoice" type="text" pInputText
                        [(ngModel)]="selectedEditOrder.invoice_details.tax_number">
                </div>
            </div>


            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <label class="label">Ulica</label>
                    <input class="input-invoice" type="text" pInputText
                        [(ngModel)]="selectedEditOrder.invoice_details.street">
                </div>
            </div>

            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <label class="label">Numer domu</label>
                    <input class="input-invoice" type="text" pInputText
                        [(ngModel)]="selectedEditOrder.invoice_details.street_number">
                </div>
            </div>



            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <label class="label">Nr mieszkania</label>
                    <input class="input-invoice" type="text" pInputText
                        [(ngModel)]="selectedEditOrder.invoice_details.apartment_number">
                </div>
            </div>




            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <label class="label">Kod pocztowy</label>
                    <input class="input-invoice" type="text" pInputText
                        [(ngModel)]="selectedEditOrder.invoice_details.postal_code">
                </div>
            </div>

            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <label class="label">Miasto</label>
                    <input class="input-invoice" type="text" pInputText
                        [(ngModel)]="selectedEditOrder.invoice_details.city">
                </div>
            </div>

            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <p-checkbox [label]="'Faktura na termin'" [binary]="true" [(ngModel)]="selectedEditOrder.invoice_details.invoice_terms"></p-checkbox>
                </div>
            </div>

            <div *ngIf="selectedEditOrder.invoice_details.invoice_terms" class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <label class="label">Termin (Wpisz ilość dni. Np: 7 lub 14)</label>
                    <input class="input-invoice" type="text" pInputText
                        [(ngModel)]="selectedEditOrder.invoice_details.invoice_terms_days">
                </div>
            </div>

            <br/><br/>
            <h4 style="margin:0;padding:0">Odbiorca</h4>
            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <label class="label">Nazwa firmy</label>
                    <input class="input-invoice" type="text" pInputText
                        [(ngModel)]="selectedEditOrder.invoice_details.recipient_name">
                </div>
            </div>

            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <label class="label">Miasto</label>
                    <input class="input-invoice" type="text" pInputText
                        [(ngModel)]="selectedEditOrder.invoice_details.recipient_city">
                </div>
            </div>

            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <label class="label">Ulica</label>
                    <input class="input-invoice" type="text" pInputText
                        [(ngModel)]="selectedEditOrder.invoice_details.recipient_street">
                </div>
            </div>

            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <label class="label">Numer domu/mieszkania</label>
                    <input class="input-invoice" type="text" pInputText
                        [(ngModel)]="selectedEditOrder.invoice_details.recipient_street_number">
                </div>
            </div>

            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <label class="label">Kod pocztowy</label>
                    <input class="input-invoice" type="text" pInputText
                        [(ngModel)]="selectedEditOrder.invoice_details.recipient_postal_code">
                </div>
            </div>

            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <div class="ui-g">
                    <button [disabled]="savingInvoice" pButton type="button" label="Zapisz dane"
                        (click)="onSaveEditedInvoice()">
                        <app-loader *ngIf="savingInvoice" [center]="true" [size]="30"></app-loader>
                    </button>
                </div>
            </div>

        </div>
    </div>
</p-dialog>
